import { composer } from '../../component-decorators/composer';
import { useConfigContext } from '../../config-context';
import { WithFetcher } from '../../component-decorators/with-fetcher';
import { CenteredLoader } from '../centered-loader';
import { config } from '../../config';
import { AppErrorPageSeo } from './app-error-page-seo';
import { httpClient } from '../../http-client';
import React from 'react';
import { ErrorPage } from '../error-page';
import { ErrorPageType, Origin } from '../..';
export var ErrorPageContainer = composer()
    .withTranslation()
    .compose(function (_a) {
    var slug = _a.slug, errorPageType = _a.errorPageType, t = _a.t;
    // tslint:disable-next-line:react-hooks-nesting
    var locale = useConfigContext().locale;
    var getErrorPageType = function (appName) {
        return errorPageType
            ? errorPageType
            : appName
                ? ErrorPageType.NOT_AVAILABLE_APP
                : ErrorPageType.NOT_FOUND;
    };
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: fetchErrorPageData(slug, locale), fetchMemoizationId: "error-page-container-" + slug + "-" + locale }, function (_a) {
        var fetchData = _a.fetchData;
        return (React.createElement("div", { "data-testid": 'error-page-container' },
            config.origin === Origin.STANDALONE && fetchData.appName && (React.createElement(AppErrorPageSeo, { appName: fetchData.appName, appSlug: slug })),
            React.createElement(ErrorPage, { appName: fetchData.appName, categories: fetchData.categories, errorPageType: getErrorPageType(fetchData.appName), t: t })));
    }));
});
export var fetchErrorPageData = function (slug, locale) {
    if (locale === void 0) { locale = 'en'; }
    return function () {
        return slug
            ? fetchAppErrorPageData(slug, locale)
            : fetchDefaultErrorPageData(locale);
    };
};
export var fetchAppErrorPageData = function (slug, locale) {
    if (locale === void 0) { locale = 'en'; }
    return Promise.all([
        httpClient.get(config.baseApiUrl + "/_api/marketplace-api/v1/categories?lang=" + locale),
        httpClient.post(config.baseApiUrl + "/_api/app-service/v2/market-versions/" + slug, { status: ['APPROVED', 'DECLINED'], languageCode: locale }, {
            headers: {
                Host: config.baseApiUrl.replace(/(^\w+:|^)\/\//, ''),
            },
        }),
    ])
        .then(function (_a) {
        var categoryResponse = _a[0], appResponse = _a[1];
        return {
            appName: appResponse.data &&
                appResponse.data.appsVersions[0] &&
                appResponse.data.appsVersions[0].marketListing &&
                appResponse.data.appsVersions[0].marketListing.basicInfo.name,
            categories: categoryResponse.data.categoryToSubCategory,
        };
    })
        .catch(function (error) { return console.log(error); });
};
var fetchDefaultErrorPageData = function (locale) {
    if (locale === void 0) { locale = 'en'; }
    return httpClient
        .get(config.baseApiUrl + "/_api/marketplace-api/v1/categories?lang=" + locale)
        .then(function (_a) {
        var data = _a.data;
        return {
            categories: data.categoryToSubCategory,
        };
    })
        .catch(function (error) { return console.log(error); });
};
//# sourceMappingURL=error-page-container.js.map